import { deserialize } from 'cerialize'
import { getDate, getTime } from 'Helpers'
import { RoleModel, InterfaceElementModel, ReceivingFileModel } from 'Models'
import { BannerUITypes } from 'LibNeo'
import { NotificationTypes, DisplayNotification } from 'Pages/admin'

export class ServiceNotification {
	@deserialize public id: number
	@deserialize public priority: number
	@deserialize public title: string
	@deserialize public content: string
	@deserialize public created_at?: string
	@deserialize public button_name: string
	@deserialize public url?: string
	@deserialize public active?: boolean
	@deserialize public roles: RoleModel[]
	@deserialize public role_ids: number[]
	@deserialize public interface_elements: InterfaceElementModel[]
	@deserialize public interface_element_ids: number[]
	@deserialize public users_count: number
	@deserialize public partner_access_periods: number[]
	@deserialize public display_notification: DisplayNotification
	@deserialize public kind: NotificationTypes
	@deserialize public color_shade: BannerUITypes
	@deserialize public picture_file_name: string
	@deserialize public picture: ReceivingFileModel
	@deserialize public first_sign_in: boolean
	@deserialize public sign_in_after_3_months: boolean
	@deserialize public channels: { id: number; name: string }[]
	@deserialize public channel_ids: number[]

	public constructor(obj) {
		if (!obj) return
		this.id = obj.id
		this.priority = obj.priority
		this.title = obj.title
		this.created_at = obj.created_at
		this.content = obj.content
		this.button_name = obj.button_name
		this.active = obj.active ?? false
		this.url = obj.url
		if (obj.roles) {
			this.roles = obj.roles
			this.role_ids = this.get_role_ids
		}
		if (obj.interface_elements) {
			this.interface_elements = obj.interface_elements
			this.interface_element_ids = this.get_interface_element_ids
		}
		this.users_count = obj.users_count ?? 0
		this.partner_access_periods = obj.partner_access_periods
		this.display_notification = obj.display_notification
		this.kind = obj.kind
		this.color_shade = obj.color_shade
		this.picture = obj.picture
		this.picture_file_name = obj.picture_file_name
		this.first_sign_in = obj.first_sign_in
		this.sign_in_after_3_months = obj.sign_in_after_3_months
		if (obj.channels) {
			this.channels = obj.channels
			this.channel_ids = this.get_channel_ids
		}
	}

	public get created_date(): string {
		return `${getDate(this.created_at)} ${getTime(this.created_at)}`
	}

	public get get_role_ids() {
		return (this.roles || []).map((role): number => role.id)
	}

	public get get_channel_ids() {
		return (this.channels || []).map((channel): number => channel.id)
	}

	public get get_interface_element_ids() {
		return (this.interface_elements || []).map((element): number => element.id)
	}
}
